import { useState } from 'react';
import { useExpressCheckoutButtonsProps } from '../../provider/useExpressCheckoutButtonsProps';
import { ExpressCheckoutModalType } from './ExpressCheckoutErrorModal.utils';
const getModalType = _ref => {
  let isShippable = _ref.isShippable,
    canBusinessShip = _ref.canBusinessShip,
    isPremium = _ref.isPremium,
    isOwner = _ref.isOwner,
    viewMode = _ref.viewMode;
  if (!isPremium) {
    return isOwner ? ExpressCheckoutModalType.OwnerNoPremium : ExpressCheckoutModalType.BuyerNoPremium;
  }
  if (isShippable && !canBusinessShip) {
    return isOwner ? ExpressCheckoutModalType.OwnerNoShipping : ExpressCheckoutModalType.BuyerNoShipping;
  }
  if (viewMode === 'Preview') {
    return ExpressCheckoutModalType.PreviewMode;
  }
  return undefined;
};
export const useCheckoutErrorModal = _ref2 => {
  let isShippable = _ref2.isShippable;
  const data = useExpressCheckoutButtonsProps();
  const _ref3 = data ?? {},
    isDisplayErrorModalsEnabled = _ref3.isDisplayErrorModalsEnabled,
    canBusinessShip = _ref3.canBusinessShip,
    isPremium = _ref3.isPremium,
    isOwner = _ref3.isOwner,
    viewMode = _ref3.viewMode;
  const _useState = useState(false),
    isCheckoutErrorModalOpen = _useState[0],
    setIsCheckoutErrorModalOpen = _useState[1];
  const modalType = isDisplayErrorModalsEnabled ? getModalType({
    isShippable,
    canBusinessShip,
    isPremium,
    isOwner,
    viewMode
  }) : undefined;
  return {
    modalType,
    isCheckoutErrorModalOpen,
    openCheckoutErrorModal: () => setIsCheckoutErrorModalOpen(true),
    closeCheckoutErrorModal: () => {
      setIsCheckoutErrorModalOpen(false);
      data == null || data.onCancel == null || data.onCancel();
    }
  };
};
//# sourceMappingURL=useCheckoutErrorModal.js.map